import type { PsfPromoteOrSharePageState } from './types';

export function initialState(): PsfPromoteOrSharePageState {
	return {
		moreWaysExpanded: false,
	};
}
